module.exports = __webpack_public_path__ + "static/media/003-Informieren_ID_1.5afc57aa.mp3";